// extracted by mini-css-extract-plugin
export default {"row":"Body_row__MgpXW","expandedRow":"Body_expandedRow__3umgH","column":"Body_column__qvbGy","emptyData":"Body_emptyData__Vi5Ua","emptyImage":"Body_emptyImage__iV6nr"};